import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Group extends OBase {
  update () {

  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Group.js